const constants = require('@/util/constants')
require('./config')

/**
 * 加载满意度记录
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getRates (page, size, successcb, failedcb) {
  axios.get('/api/rate/get', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 搜索过滤历史评价
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function filterRate (page, size, nickname, createdAtStart, createdAtEnd,
  workGroupNickname, agentRealName, client, successcb, failedcb) {
  axios.get('/api/rate/filter', {
    params: {
      'page': page,
      'size': size,
      'nickname': nickname,
      'createdAtStart': createdAtStart,
      'createdAtEnd': createdAtEnd,
      'workGroupNickname': workGroupNickname,
      'agentRealName': agentRealName,
      'client': client
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 客服发起评价邀请
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function inviteRate (tid, successcb, failedcb) {
  axios.post('/api/rate/invite', {
    tid: tid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 评价客服后台
 */
export function rateChatPlatform (score, note, successcb, failedcb) {
  axios.post('/api/rate/chatPlatform', {
    score,
    note,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}
